@if(question.options.length > 0) {
  <select [formControlName]="question.key"
          class="form-select"
          [id]="question.key"
          [required]="question.required">
    @for(opt of question.options; track opt) {
      <option [value]="opt.key">{{opt.value}}</option>
    }
  </select>
} @else {
  <span class="text-danger">Aucune option disponible</span>
}
